function buildApiUrl(baseURL, service = "", url = "") {
  const parts = [String(baseURL || "").replace(/\/+$/, "")];
  const servicePart = String(service || "").replace(/^\/+|\/+$/g, "");
  const urlPart = String(url || "").replace(/^\/+/, "");
  if (servicePart) parts.push(servicePart);
  if (urlPart) parts.push(urlPart);
  const joined = parts.join("/");
  // Django answers a slashless path with a redirect whose Location drops the
  // /prod-api proxy prefix, so the browser lands on the SPA shell and the
  // caller parses index.html as JSON. Keep the caller's trailing slash.
  return String(url).endsWith("/") && !joined.endsWith("/") ? `${joined}/` : joined;
}

module.exports = { buildApiUrl };
